import { IconButton } from '@src/common/components/IconButton';
import { Language } from '@src/common/i18n/Language';
import { useSelectedLanguage } from '@src/common/i18n/useSelectedLanguage';
import { css } from '@src/common/styles/Styles';
import { useTranslation } from 'react-i18next';

export const ChangeLocaleButton = () => {
  const { i18n } = useTranslation();
  const { selectedLanguage } = useSelectedLanguage();

  return (
    <div className={controls}>
      <IconButton
        onClick={() =>
          i18n.changeLanguage(
            selectedLanguage === Language.FR ? Language.EN : Language.FR,
          )
        }
      >
        {selectedLanguage.toUpperCase()}
      </IconButton>
    </div>
  );
};

const controls = css({
  display: 'flex',
  gap: '8px',
});
